import { useEffect, useState } from 'react'

// FIXME: temporary — suppress the close-button focus ring on auto-open until Farol fixes :focus-visible @gabrielrtakeda
export function useFocusRingSuppressedUntilTab() {
  const [suppressed, setSuppressed] = useState(true)

  useEffect(() => {
    function handleFirstTab(e: KeyboardEvent) {
      if (e.key !== 'Tab') return
      setSuppressed(false)
      window.removeEventListener('keydown', handleFirstTab)
    }

    window.addEventListener('keydown', handleFirstTab)
    return () => window.removeEventListener('keydown', handleFirstTab)
  }, [])

  return suppressed
}
